<template>
  <div>
    <div id="shopping-cart" v-if="drugGroups.length > 0">
      <button type="button" class="btn btn-default" @click="showCartModal = true">
        <span class="glyphicon glyphicon-shopping-cart"></span> Drug Allocation
      </button>
    </div>

    <modal v-if="showCartModal" @close="showCartModal = false">
      <div slot="header">
        <h3>Allocate Drugs</h3>
      </div>
      <div slot="body">
        <drug-allocation-inputs :animal-type="animalType"
                                :drugGroups="drugGroups">
        </drug-allocation-inputs>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Modal from '@/components/Modal'
import DrugAllocationInputs from './DrugAllocationInputs'

export default {
  name: 'DrugAllocationCart',
  props: {
    drugGroups: Array,
    animalType: String,
  },
  components: {
    Modal,
    DrugAllocationInputs,
  },
  data() {
    return {
      showCartModal: false,
    }
  },
  computed: {
    ...mapGetters('currentConsult', ['newAnimals', 'animals']),
  },
};
</script>

<style scoped>
#shopping-cart {
  position: fixed;
  bottom: 10px;
  right: 10px;
}
</style>
